<template>
  <div class="loading-wrapper-terms" v-if="isActive">
    <div :class="'loading-popup-terms popup-' + type" style="height: 80vh;">
      <div style="position: absolute; right: 0; margin: 20px;" @click="closePopup">
        <img src="/close-icon.png" style="width: 30px;" alt="">
      </div>
      <div class="h-100 m-5">
        <div class="body-devided">
          <div
            v-if="hint"
            class="hint"
            style="font-size: 26px; margin: 0 auto;"
          >
            <span>{{ hint }}</span>
          </div>
        </div>
        <div class="body-text">
          <div v-if="language == 'en'">
            <p>
              1. Introduction<br />
              1.1 These terms and conditions shall govern your use of our
              website.
            </p>

            <p>
              1.2 By using our website, you accept these terms and conditions in
              full; accordingly, if you disagree with these terms and conditions
              or any part of these terms and conditions, you must not use our
              website.
            </p>

            <p>
              1.3 If you register with our website, submit any material to our
              website or use any of our website services, we will ask you to
              expressly agree to these terms and conditions.
            </p>

            <p>
              1.4 You must be at least 18 years of age to use our website; by
              using our website or agreeing to these terms and conditions, you
              warrant and represent to us that you are at least 18 years of age.
            </p>

            <p>
              1.5 Our website uses cookies; by using our website or agreeing to
              these terms and conditions, you consent to our use of cookies in
              accordance with the terms of our privacy and cookies policy.
            </p>

            <p></p>

            <p>
              2. Copyright notice<br />
              2.1 Copyright (c) 2020 Liberrex.
            </p>

            <p>
              2.2 Subject to the express provisions of these terms and
              conditions:<br />
              (a) we, together with our licensors, own and control all the
              copyright and other intellectual property rights in our website
              and the material on our website; and<br />
              (b) all the copyright and other intellectual property rights in
              our website and the material on our website are reserved.
            </p>

            <p></p>

            <p>
              3. Licence to use website<br />
              3.1 You may:<br />
              (a) view pages from our website in a web browser;<br />
              (b) download pages from our website for caching in a web
              browser;<br />
              (c) print pages from our website;
            </p>

            <p>
              3.2 Except as expressly permitted by Section 4.1 or the other
              provisions of these terms and conditions, you must not download
              any material from our website or save any such material to your
              computer.
            </p>

            <p>
              3.3 You may only use our website for your own personal and
              business purposes , and you must not use our website for any other
              purposes.
            </p>

            <p>
              3.4 Except as expressly permitted by these terms and conditions,
              you must not edit or otherwise modify any material on our website.
            </p>

            <p>
              3.5 Unless you own or control the relevant rights in the material,
              you must not:<br />
              (a) republish material from our website (including republication
              on another website);<br />
              (b) sell, rent or sub-license material from our website;
            </p>

            <p>
              3.6 Notwithstanding Section 4.5, you may redistribute our
              newsletter in print and electronic form to any person.
            </p>

            <p>
              3.7 We reserve the right to restrict access to areas of our
              website, or indeed our whole website, at our discretion; you must
              not circumvent or bypass, or attempt to circumvent or bypass, any
              access restriction measures on our website.
            </p>

            <p></p>

            <p>
              4. Acceptable use<br />
              You must not:<br />
              (a) use our website in any way or take any action that causes, or
              may cause, damage to the website or impairment of the performance,
              availability or accessibility of the website;<br />
              (b) use our website in any way that is unlawful, illegal,
              fraudulent or harmful, or in connection with any unlawful,
              illegal, fraudulent or harmful purpose or activity;<br />
              (c) use our website to copy, store, host, transmit, send, use,
              publish or distribute any material which consists of (or is linked
              to) any spyware, computer virus, Trojan horse, worm, keystroke
              logger, rootkit or other malicious computer software;<br />
              (d) conduct any systematic or automated data collection activities
              (including without limitation scraping, data mining, data
              extraction and data harvesting) on or in relation to our website
              without our express written consent;<br />
              (e) access or otherwise interact with our website using any robot,
              spider or other automated means, except for the purpose of search
              engine indexing;<br />
              (f) violate the directives set out in the robots.txt file for our
              website; or<br />
              (g) use data collected from our website for any direct marketing
              activity (including without limitation email marketing, SMS
              marketing, telemarketing and direct mailing).
            </p>

            <p>
              4.2 You must not use data collected from our website to contact
              individuals, companies or other persons or entities.
            </p>

            <p>
              4.3 You must ensure that all the information you supply to us
              through our website, or in relation to our website, is true,
              accurate, current, complete and non-misleading.
            </p>

            <p></p>

            <p>
              5. Registration and accounts<br />
              5.1 To be eligible for an individual account on our website under
              this Section 5, you must be at least 18 years of age.
            </p>

            <p>
              5.2 You may register for an account with our website by completing
              and submitting the account registration form on our website, and
              clicking on the verification link in the email that the website
              will send to you.
            </p>

            <p>
              5.3 You must not allow any other person to use your account to
              access the website.
            </p>

            <p>
              5.4 You must notify us in writing immediately if you become aware
              of any unauthorised use of your account.
            </p>

            <p>
              5.5 You must not use any other person&rsquo;s account to access
              the website, unless you have that person&rsquo;s express
              permission to do so.
            </p>

            <p></p>

            <p>
              user-login<br />
              6.1 If you register for an account with our website, we will
              provide you with OR you will be asked to choose a user ID and
              password.
            </p>

            <p>
              6.2 Your user ID must not be liable to mislead and must comply
              with the content rules set out in Section 8; you must not use your
              account or user ID for or in connection with the impersonation of
              any person.
            </p>

            <p>6.3 You must keep your password confidential.</p>

            <p>
              6.4 You must notify us in writing immediately if you become aware
              of any disclosure of your password.
            </p>

            <p>
              6.5 You are responsible for any activity on our website arising
              out of any failure to keep your password confidential, and may be
              held liable for any losses arising out of such a failure.
            </p>

            <p></p>

            <p>
              7. Cancellation and suspension of account<br />
              7.1 We may:<br />
              (a) suspend your account;<br />
              (b) cancel your account; ; and/or<br />
              (c) edit your account details,<br />
              at any time in our sole discretion without notice or explanation.
            </p>

            <p>
              7.2 You may cancel your account on our website using your account
              control panel on the website.
            </p>

            <p></p>

            <p>
              8. Your content: licence<br />
              8.1 In these terms and conditions, &ldquo;your content&rdquo;
              means all works and materials (including without limitation text,
              graphics, images, audio material, video material, audio-visual
              material, scripts, software and files) that you submit to us or
              our website for storage or publication on, processing by, or
              transmission via, our website.
            </p>

            <p>
              8.2 You grant to us a worldwide, irrevocable, non-exclusive,
              royalty-free licence to use, reproduce, store, adapt, publish,
              translate and distribute your content in any existing or future
              media OR reproduce, store and publish your content on and in
              relation to this website and any successor website OR reproduce,
              store and, with your specific consent, publish your content on and
              in relation to this website.
            </p>

            <p>
              8.3 You grant to us the right to sub-license the rights licensed
              under Section 8.2.
            </p>

            <p>
              8.4 You grant to us the right to bring an action for infringement
              of the rights licensed under Section 8.2.
            </p>

            <p>
              8.5 You hereby waive all your moral rights in your content to the
              maximum extent permitted by applicable law; and you warrant and
              represent that all other moral rights in your content have been
              waived to the maximum extent permitted by applicable law.
            </p>

            <p>
              8.6 You may edit your content to the extent permitted using the
              editing functionality made available on our website.
            </p>

            <p>
              8.7 Without prejudice to our other rights under these terms and
              conditions, if you breach any provision of these terms and
              conditions in any way, or if we reasonably suspect that you have
              breached these terms and conditions in any way, we may delete,
              unpublish or edit any or all of your content.
            </p>

            <p></p>

            <p>
              9. Your content: rules<br />
              9.1 You warrant and represent that your content will comply with
              these terms and conditions.
            </p>

            <p>
              9.2 Your content must not be illegal or unlawful, must not
              infringe any person&rsquo;s legal rights, and must not be capable
              of giving rise to legal action against any person (in each case in
              any jurisdiction and under any applicable law).
            </p>

            <p>
              9.3 Your content, and the use of your content by us in accordance
              with these terms and conditions, must not:<br />
              (a) be libellous or maliciously false;<br />
              (b) be obscene or indecent;<br />
              (c) infringe any copyright, moral right, database right, trade
              mark right, design right, right in passing off, or other
              intellectual property right;<br />
              (d) infringe any right of confidence, right of privacy or right
              under data protection legislation;<br />
              (e) constitute negligent advice or contain any negligent
              statement;<br />
              (f) constitute an incitement to commit a crime, ; instructions for
              the commission of a crime or the promotion of criminal
              activity;<br />
              (g) be in contempt of any court, or in breach of any court
              order;<br />
              (h) be in breach of racial or religious hatred or discrimination
              legislation;<br />
              (i) be blasphemous;<br />
              (j)be in breach of official secrets legislation;<br />
              (k)be in breach of any contractual obligation owed to any
              person;<br />
              (l) L9-3-l-1 in an explicit, graphic or gratuitous manner;<br />
              (m) be pornographic, lewd, suggestive or sexually explicit, ;<br />
              (n) be untrue, false, inaccurate or misleading;<br />
              (o) consist of or contain any instructions, advice or other
              information which may be acted upon and could, if acted upon,
              cause illness, injury or death, or any other loss or damage;<br />
              (p) constitute spam;<br />
              (q) be offensive, deceptive, fraudulent, threatening, abusive,
              harassing, anti-social, menacing, hateful, discriminatory or
              inflammatory; or<br />
              (r) cause annoyance, inconvenience or needless anxiety to any
              person.
            </p>

            <p></p>

            <p>
              10. Limited warranties<br />
              10.1 We do not warrant or represent:<br />
              (a) the completeness or accuracy of the information published on
              our website;<br />
              (b) that the material on the website is up to date; or<br />
              (c) that the website or any service on the website will remain
              available.
            </p>

            <p>
              10.2 We reserve the right to discontinue or alter any or all of
              our website services, and to stop publishing our website, at any
              time in our sole discretion without notice or explanation; and
              save to the extent expressly provided otherwise in these terms and
              conditions, you will not be entitled to any compensation or other
              payment upon the discontinuance or alteration of any website
              services, or if we stop publishing the website.
            </p>

            <p>
              10.3 To the maximum extent permitted by applicable law and subject
              to Section 11.1, we exclude all representations and warranties
              relating to the subject matter of these terms and conditions, our
              website and the use of our website.
            </p>

            <p></p>

            <p>
              11. Limitations and exclusions of liability<br />
              11.1 Nothing in these terms and conditions will:<br />
              (a) limit or exclude any liability for death or personal injury
              resulting from negligence;<br />
              (b) limit or exclude any liability for fraud or fraudulent
              misrepresentation;<br />
              (c) limit any liabilities in any way that is not permitted under
              applicable law; or<br />
              (d) exclude any liabilities that may not be excluded under
              applicable law.
            </p>

            <p>
              11.2 The limitations and exclusions of liability set out in this
              Section 11 and elsewhere in these terms and conditions:<br />
              (a) (a) are subject to Section 11.1; and<br />
              (b) (b) govern all liabilities arising under these terms and
              conditions or relating to the subject matter of these terms and
              conditions, including liabilities arising in contract, in tort
              (including negligence) and for breach of statutory duty, except to
              the extent expressly provided otherwise in these terms and
              conditions.
            </p>

            <p>
              11.3 To the extent that our website and the information and
              services on our website are provided free of charge, we will not
              be liable for any loss or damage of any nature.
            </p>

            <p>
              11.4 We will not be liable to you in respect of any losses arising
              out of any event or events beyond our reasonable control.
            </p>

            <p>
              11.5 We will not be liable to you in respect of any business
              losses, including (without limitation) loss of or damage to
              profits, income, revenue, use, production, anticipated savings,
              business, contracts, commercial opportunities or goodwill.
            </p>

            <p>
              11.6 We will not be liable to you in respect of any loss or
              corruption of any data, database or software.p>
            </p>

            <p>
              11.7 We will not be liable to you in respect of any special,
              indirect or consequential loss or damage.p>
            </p>

            <p>
              11.8 You accept that we have an interest in limiting the personal
              liability of our officers and employees and, having regard to that
              interest, you acknowledge that we are a limited liability entity;
              you agree that you will not bring any claim personally against our
              officers or employees in respect of any losses you suffer in
              connection with the website or these terms and conditions (this
              will not, of course, limit or exclude the liability of the limited
              liability entity itself for the acts and omissions of our officers
              and employees).
            </p>

            <p></p>

            <p>
              12. Breaches of these terms and conditions<br />
              12.1 Without prejudice to our other rights under these terms and
              conditions, if you breach these terms and conditions in any way,
              or if we reasonably suspect that you have breached these terms and
              conditions in any way, we may:<br />
              (a) (a) send you one or more formal warnings;<br />
              (b) (b) temporarily suspend your access to our website;<br />
              (c) (c) permanently prohibit you from accessing our website;<br />
              (d) (d) block computers using your IP address from accessing our
              website;<br />
              (e) (e) contact any or all of your internet service providers and
              request that they block your access to our website;<br />
              (f) (f) commence legal action against you, whether for breach of
              contract or otherwise; and/or<br />
              (g) suspend or delete your account on our website.
            </p>

            <p>
              12.2 Where we suspend or prohibit or block your access to our
              website or a part of our website, you must not take any action to
              circumvent such suspension or prohibition or blocking (including
              without limitation creating and/or using a different account).
            </p>

            <p></p>

            <p>
              13. Variation<br />
              13.1 We may revise these terms and conditions from time to time.
            </p>

            <p>
              13.2 OR The revised terms and conditions shall apply to the use of
              our website from the date of publication of the revised terms and
              conditions on the website, and you hereby waive any right you may
              otherwise have to be notified of, or to consent to, revisions of
              these terms and conditions.
            </p>

            <p>
              13.3 If you have given your express agreement to these terms and
              conditions, we will ask for your express agreement to any revision
              of these terms and conditions; and if you do not give your express
              agreement to the revised terms and conditions within such period
              as we may specify, we will disable or delete your account on the
              website, and you must stop using the website.
            </p>

            <p></p>

            <p>
              14. Assignment<br />
              14.1 You hereby agree that we may assign, transfer, sub-contract
              or otherwise deal with our rights and/or obligations under these
              terms and conditions.
            </p>

            <p>
              14.2 You may not without our prior written consent assign,
              transfer, sub-contract or otherwise deal with any of your rights
              and/or obligations under these terms and conditions.
            </p>

            <p></p>

            <p>
              15. Severability<br />
              15.1 If a provision of these terms and conditions is determined by
              any court or other competent authority to be unlawful and/or
              unenforceable, the other provisions will continue in effect.
            </p>

            <p>
              15.2 If any unlawful and/or unenforceable provision of these terms
              and conditions would be lawful or enforceable if part of it were
              deleted, that part will be deemed to be deleted, and the rest of
              the provision will continue in effect.
            </p>

            <p></p>

            <p>
              16. Third party rights<br />
              16.1 A contract under these terms and conditions is for our
              benefit and your benefit, and is not intended to benefit or be
              enforceable by any third party.
            </p>

            <p>
              16.2 The exercise of the parties&rsquo; rights under a contract
              under these terms and conditions is not subject to the consent of
              any third party.
            </p>

            <p></p>

            <p>
              17. Entire agreement<br />
              17.1 Subject to Section 11.1, these terms and conditions, together
              with our privacy and cookies policy, shall constitute the entire
              agreement between you and us in relation to your use of our
              website and shall supersede all previous agreements between you
              and us in relation to your use of our website.
            </p>

            <p></p>

            <p>
              18. Law and jurisdiction<br />
              18.1 These terms and conditions shall be governed by and construed
              in accordance with English, Spanish, French, Tunisian, Algerian,
              Portuguese and Moroccan law.
            </p>

            <p>
              18.2 Any disputes relating to these terms and conditions shall be
              subject to the exclusive OR non-exclusive jurisdiction of the
              courts of England, Spain, France, Tunisia, Algeria, Portugal and
              Morocco.
            </p>

            <p>
              19. Statutory and regulatory disclosures<br />
              19.1 We are registered in trade register; ; you can find the
              online version of the register at URLURL , and our registration
              number is .
            </p>

            <p>
              19.2 We are subject to authorisation scheme, which is supervised
              by supervisory authority.
            </p>

            <p>
              19.3 We are registered as title with professional body in the
              United Kingdom and are subject to rules, which can be found at
              URL.
            </p>

            <p>
              19.4 We subscribe to , which can be consulted electronically at
              code(s) of conduct URL(s).
            </p>

            <p>static.L19-5-1 static.L19-5-2.</p>

            <p></p>

            <p>
              20. Our details<br />
              20.1 This website is owned and operated by Liberrex LTD .
            </p>

            <p>
              20.2 We are registered in England and Wales under registration
              number 11797740, and our registered office is at Unit 6 Queens
              Yard, White Post Lane, London, United Kingdom, E9 5EN.
            </p>

            <p>
              20.3 Our principal place of business is at Google Campus, Bonhill
              Street, London, United Kingdom.
            </p>

            <p>
              20.4 You can contact us:<br />
              (a) by post, using the postal address given above ;<br />
              (b) using our website contact form;<br />
              (c) by telephone, on by telephone, on 0044 7802 40 5359; OR<br />
              (d) by email, using the email address published on our website
              from time to time.
            </p>
          </div>
          <div v-else>
            <p>1. Introduction</p>

            <p>
              1.1 Ces termes et conditions r&eacute;giront votre utilisation de
              notre site Web.
            </p>

            <p>
              1.2 En utilisant notre site Web, vous acceptez ces termes et
              conditions dans leur int&eacute;gralit&eacute;; Par
              cons&eacute;quent, si vous n&rsquo;&ecirc;tes pas d&rsquo;accord
              avec ces termes et conditions ou toute partie de ces termes et
              conditions, vous ne devez pas utiliser notre site Web.
            </p>

            <p>
              1.3 Si vous vous inscrivez sur notre site Web, soumettez du
              mat&eacute;riel &agrave; notre site Web ou utilisez l&rsquo;un de
              nos services de site Web, nous vous demanderons d&rsquo;accepter
              express&eacute;ment ces termes et conditions.
            </p>

            <p>
              1.4 Vous devez &ecirc;tre &acirc;g&eacute; d&rsquo;au moins 18 ans
              pour utiliser notre site Web; en utilisant notre site Web ou en
              acceptant ces termes et conditions, vous garantissez et nous
              d&eacute;clarez que vous avez au moins 18 ans.
            </p>

            <p>
              1.5 Notre site Web utilise des cookies; en utilisant notre site
              Web ou en acceptant ces termes et conditions, vous consentez
              &agrave; notre utilisation des cookies conform&eacute;ment aux
              termes de notre politique de confidentialit&eacute; et de cookies.
            </p>

            <p></p>

            <p>2. Avis de droit d&rsquo;auteur</p>

            <p>2.1 Copyright (c) 2021 Liberrex.</p>

            <p>
              2.2 Sous r&eacute;serve des dispositions expresses des
              pr&eacute;sentes conditions g&eacute;n&eacute;rales:<br />
              (a) nous, avec nos conc&eacute;dants de licence, poss&eacute;dons
              et contr&ocirc;lons tous les droits d&rsquo;auteur et autres
              droits de propri&eacute;t&eacute; intellectuelle sur notre site
              Web et le mat&eacute;riel sur notre site Web; et<br />
              (b) tous les droits d&rsquo;auteur et autres droits de
              propri&eacute;t&eacute; intellectuelle de notre site Web et du
              mat&eacute;riel de notre site Web sont r&eacute;serv&eacute;s.
            </p>

            <p></p>

            <p>3. Licence d&rsquo;utilisation du site Web</p>

            <p>
              3.1 Vous pouvez:<br />
              (a) afficher les pages de notre site Web dans un navigateur
              Web;<br />
              (b) t&eacute;l&eacute;charger des pages de notre site Web pour la
              mise en cache dans un navigateur Web;<br />
              (c) imprimer des pages de notre site Web;
            </p>

            <p>
              3.2 Sauf dans la mesure express&eacute;ment autoris&eacute;e par
              la section 4.1 ou les autres dispositions des pr&eacute;sentes
              conditions g&eacute;n&eacute;rales, vous ne devez
              t&eacute;l&eacute;charger aucun mat&eacute;riel de notre site Web
              ou enregistrer un tel mat&eacute;riel sur votre ordinateur.
            </p>

            <p>
              3.3 Vous ne pouvez utiliser notre site Web qu&rsquo;&agrave; des
              fins personnelles et professionnelles, et vous ne devez pas
              utiliser notre site Web &agrave; d&rsquo;autres fins.
            </p>

            <p>
              3.4 Sauf dans les cas express&eacute;ment autoris&eacute;s par ces
              termes et conditions, vous ne devez pas &eacute;diter ou autrement
              modifier tout mat&eacute;riel sur notre site Web.
            </p>

            <p>
              3.5 Sauf si vous poss&eacute;dez ou contr&ocirc;lez les droits
              pertinents sur le mat&eacute;riel, vous ne devez pas:<br />
              (a) republier le mat&eacute;riel de notre site Web (y compris la
              republication sur un autre site Web);<br />
              (b) vendre, louer ou sous-licencier du mat&eacute;riel de notre
              site Web;
            </p>

            <p>
              3.6 Nonobstant la section 4.5, vous pouvez redistribuer notre
              newsletter sous forme imprim&eacute;e et &eacute;lectronique
              &agrave; toute personne.
            </p>

            <p>
              3.7 Nous nous r&eacute;servons le droit de restreindre
              l&rsquo;acc&egrave;s &agrave; des zones de notre site Web, voire
              &agrave; l&rsquo;ensemble de notre site Web, &agrave; notre
              discr&eacute;tion; vous ne devez pas contourner ou contourner, ou
              tenter de contourner ou de contourner, les mesures de restriction
              d&rsquo;acc&egrave;s sur notre site Web.
            </p>

            <p></p>

            <p>4. Utilisation acceptable</p>

            <p>
              Vous ne devez pas:<br />
              (a) utiliser notre site Web de quelque mani&egrave;re que ce soit
              ou prendre toute action qui cause, ou pourrait causer, des
              dommages au site Web ou une alt&eacute;ration des performances, de
              la disponibilit&eacute; ou de l&rsquo;accessibilit&eacute; du site
              Web;<br />
              (b) utiliser notre site Web de quelque mani&egrave;re que ce soit
              qui soit ill&eacute;gale, ill&eacute;gale, frauduleuse ou
              nuisible, ou en relation avec un but ou une activit&eacute;
              ill&eacute;gale, ill&eacute;gale, frauduleuse ou nuisible;<br />
              (c) utiliser notre site Web pour copier, stocker, h&eacute;berger,
              transmettre, envoyer, utiliser, publier ou distribuer tout
              mat&eacute;riel qui consiste en (ou est li&eacute; &agrave;) un
              logiciel espion, un virus informatique, un cheval de Troie, un
              ver, un enregistreur de frappe, un rootkit ou autre logiciels
              informatiques malveillants;<br />
              (d) mener des activit&eacute;s de collecte de donn&eacute;es
              syst&eacute;matiques ou automatis&eacute;es (y compris, sans
              s&rsquo;y limiter, le grattage, l&rsquo;extraction de
              donn&eacute;es, l&rsquo;extraction de donn&eacute;es et la
              collecte de donn&eacute;es) sur ou en relation avec notre site Web
              sans notre consentement &eacute;crit expr&egrave;s;<br />
              (e) acc&eacute;der ou interagir d&rsquo;une autre mani&egrave;re
              avec notre site Web en utilisant un robot, une araign&eacute;e ou
              d&rsquo;autres moyens automatis&eacute;s, sauf aux fins de
              l&rsquo;indexation des moteurs de recherche;<br />
              (f) enfreindre les directives &eacute;nonc&eacute;es dans le
              fichier robots.txt de notre site Web; ou<br />
              (g) utiliser les donn&eacute;es collect&eacute;es sur notre site
              Web pour toute activit&eacute; de marketing direct (y compris,
              sans s&rsquo;y limiter, le marketing par courrier
              &eacute;lectronique, le marketing par SMS, le
              t&eacute;l&eacute;marketing et le publipostage).
            </p>

            <p>
              4.2 Vous ne devez pas utiliser les donn&eacute;es
              collect&eacute;es sur notre site Web pour contacter des individus,
              des entreprises ou d&rsquo;autres personnes ou entit&eacute;s.
            </p>

            <p>
              4.3 Vous devez vous assurer que toutes les informations que vous
              nous fournissez via notre site Web, ou en relation avec notre site
              Web, sont vraies, exactes, actuelles, compl&egrave;tes et non
              trompeuses.
            </p>

            <p></p>

            <p>5. Inscription et comptes</p>

            <p>
              5.1 Pour &ecirc;tre &eacute;ligible &agrave; un compte individuel
              sur notre site Web en vertu de la pr&eacute;sente section 5, vous
              devez &ecirc;tre &acirc;g&eacute; d&rsquo;au moins 18 ans.
            </p>

            <p>
              5.2 Vous pouvez cr&eacute;er un compte sur notre site Web en
              remplissant et en soumettant le formulaire d&rsquo;inscription de
              compte sur notre site Web, et en cliquant sur le lien de
              v&eacute;rification dans l&rsquo;e-mail que le site Web vous
              enverra.
            </p>

            <p>
              5.3 Vous ne devez autoriser aucune autre personne &agrave;
              utiliser votre compte pour acc&eacute;der au site Web.
            </p>

            <p>
              5.4 Vous devez nous informer imm&eacute;diatement par &eacute;crit
              si vous avez connaissance d&rsquo;une utilisation non
              autoris&eacute;e de votre compte.
            </p>

            <p>
              5.5 Vous ne devez pas utiliser le compte d&rsquo;une autre
              personne pour acc&eacute;der au site Web, sauf si vous avez
              l&rsquo;autorisation expresse de cette personne de le faire.
            </p>

            <p></p>

            <p>6. Utilisateur en ligne</p>

            <p>
              6.1 Si vous cr&eacute;ez un compte sur notre site Web, nous vous
              fournirons OU il vous sera demand&eacute; de choisir un
              identifiant et un mot de passe.
            </p>

            <p>
              6.2 Votre identifiant d&rsquo;utilisateur ne doit pas &ecirc;tre
              susceptible d&rsquo;induire en erreur et doit &ecirc;tre conforme
              aux r&egrave;gles de contenu &eacute;nonc&eacute;es dans la
              section 8; vous ne devez pas utiliser votre compte ou votre
              identifiant d&rsquo;utilisateur pour ou en relation avec
              l&rsquo;usurpation d&rsquo;identit&eacute; de toute personne.
            </p>

            <p>6.3 Vous devez garder votre mot de passe confidentiel.</p>

            <p>
              6.4 Vous devez nous informer imm&eacute;diatement par &eacute;crit
              si vous avez connaissance d&rsquo;une divulgation de votre mot de
              passe.
            </p>

            <p>
              6.5 Vous &ecirc;tes responsable de toute activit&eacute; sur notre
              site Web d&eacute;coulant de tout manquement &agrave; la
              confidentialit&eacute; de votre mot de passe, et pouvez &ecirc;tre
              tenu responsable de toute perte d&eacute;coulant d&rsquo;un tel
              &eacute;chec.
            </p>

            <p></p>

            <p>7. Annulation et suspension de compte</p>

            <p>
              7.1 Nous pouvons:<br />
              (a) suspendre votre compte;<br />
              (b) annuler votre compte; ; et / ou<br />
              (c) modifier les d&eacute;tails de votre compte,<br />
              &agrave; tout moment &agrave; notre seule discr&eacute;tion sans
              pr&eacute;avis ni explication.
            </p>

            <p>
              7.2 Vous pouvez annuler votre compte sur notre site Web en
              utilisant le panneau de contr&ocirc;le de votre compte sur le site
              Web.
            </p>

            <p></p>

            <p>8. Votre contenu: licence</p>

            <p>
              8.1 Dans ces termes et conditions, &laquo;votre contenu&raquo;
              signifie tous les travaux et mat&eacute;riaux (y compris, sans
              limitation, les textes, graphiques, images, mat&eacute;riel audio,
              mat&eacute;riel vid&eacute;o, mat&eacute;riel audiovisuel,
              scripts, logiciels et fichiers) que vous nous soumettez ou
              &agrave; notre site Web pour le stockage ou la publication sur, le
              traitement ou la transmission via notre site Web.
            </p>

            <p>
              8.2 Vous nous accordez une licence mondiale, irr&eacute;vocable,
              non exclusive et sans redevance pour utiliser, reproduire,
              stocker, adapter, publier, traduire et distribuer votre contenu
              dans tout m&eacute;dia existant ou futur OU reproduire, stocker et
              publier votre contenu sur et en relation avec ce site Web et tout
              site Web successeur OU reproduisez, stockez et, avec votre
              consentement sp&eacute;cifique, publiez votre contenu sur et en
              relation avec ce site Web.
            </p>

            <p>
              8.3 Vous nous accordez le droit de sous-licencier les droits
              conc&eacute;d&eacute;s en vertu de la section 8.2.
            </p>

            <p>
              8.4 Vous nous accordez le droit d&rsquo;intenter une action pour
              violation des droits conc&eacute;d&eacute;s en vertu de la section
              8.2.
            </p>

            <p>
              8.5 Vous renoncez par la pr&eacute;sente &agrave; tous vos droits
              moraux sur votre contenu dans la mesure maximale autoris&eacute;e
              par la loi applicable; et vous garantissez et d&eacute;clarez que
              tous les autres droits moraux sur votre contenu ont
              &eacute;t&eacute; abandonn&eacute;s dans la mesure maximale
              autoris&eacute;e par la loi applicable.
            </p>

            <p>
              8.6 Vous pouvez modifier votre contenu dans la mesure permise en
              utilisant la fonctionnalit&eacute; d&rsquo;&eacute;dition mise
              &agrave; disposition sur notre site Web.
            </p>

            <p>
              8.7 Sans pr&eacute;judice de nos autres droits en vertu de ces
              termes et conditions, si vous enfreignez une disposition de ces
              termes et conditions de quelque mani&egrave;re que ce soit, ou si
              nous soup&ccedil;onnons raisonnablement que vous avez viol&eacute;
              ces termes et conditions de quelque mani&egrave;re que ce soit,
              nous pouvons supprimer, d&eacute;publier ou modifier tout ou
              partie de votre contenu.
            </p>

            <p></p>

            <p>9. Votre contenu: r&egrave;gles</p>

            <p>
              9.1 Vous garantissez et d&eacute;clarez que votre contenu sera
              conforme &agrave; ces termes et conditions.
            </p>

            <p>
              9.2 Votre contenu ne doit pas &ecirc;tre ill&eacute;gal ou
              ill&eacute;gal, ne doit pas enfreindre les droits l&eacute;gaux de
              quiconque et ne doit pas &ecirc;tre susceptible de donner lieu
              &agrave; une action en justice contre quiconque (dans chaque cas
              dans toute juridiction et en vertu de toute loi applicable).
            </p>

            <p>
              9.3 Votre contenu et l&rsquo;utilisation de votre contenu par nous
              conform&eacute;ment aux pr&eacute;sentes conditions
              g&eacute;n&eacute;rales ne doivent pas:<br />
              a) &ecirc;tre diffamatoire ou malicieusement faux;<br />
              (b) &ecirc;tre obsc&egrave;ne ou ind&eacute;cent;<br />
              (c) porter atteinte &agrave; tout droit d&rsquo;auteur, droit
              moral, droit de base de donn&eacute;es, droit de marque, droit de
              conception, droit de tromperie ou autre droit de
              propri&eacute;t&eacute; intellectuelle;<br />
              (d) enfreindre tout droit &agrave; la confiance, droit &agrave; la
              vie priv&eacute;e ou droit en vertu de la l&eacute;gislation sur
              la protection des donn&eacute;es;<br />
              (e) constituer un avis n&eacute;gligent ou contenir une
              d&eacute;claration de n&eacute;gligence;<br />
              f) constituer une incitation &agrave; commettre un crime,;
              instructions pour la commission d&rsquo;un crime ou la promotion
              d&rsquo;une activit&eacute; criminelle;<br />
              (g) &ecirc;tre coupable d&rsquo;outrage &agrave; un tribunal ou en
              violation d&rsquo;une d&eacute;cision judiciaire;<br />
              (h) enfreindre la l&eacute;gislation sur la haine ou la
              discrimination raciale ou religieuse;<br />
              (i) &ecirc;tre blasph&eacute;matoire;<br />
              (j) enfreindre la l&eacute;gislation sur les secrets officiels;<br />
              (k) &ecirc;tre en violation de toute obligation contractuelle
              envers quiconque;<br />
              (l) L9-3-l-1 de mani&egrave;re explicite, graphique ou
              gratuite;<br />
              (m) &ecirc;tre pornographique, obsc&egrave;ne, suggestif ou
              sexuellement explicite;<br />
              (n) &ecirc;tre faux, faux, inexact ou trompeur;<br />
              (o) se composent de ou contiennent des instructions, des conseils
              ou d&rsquo;autres informations qui peuvent &ecirc;tre suivis
              d&rsquo;une action et pourraient, s&rsquo;ils sont agis, causer
              une maladie, des blessures ou la mort, ou toute autre perte ou
              dommage;<br />
              (p) constituent du spam;<br />
              (q) &ecirc;tre offensant, trompeur, frauduleux, mena&ccedil;ant,
              abusif, harcelant, antisocial, mena&ccedil;ant, haineux,
              discriminatoire ou incendiaire; ou<br />
              (r) causer de la g&ecirc;ne, des inconv&eacute;nients ou de
              l&rsquo;anxi&eacute;t&eacute; inutile &agrave; quiconque.
            </p>

            <p></p>

            <p>10. Garanties limit&eacute;es</p>

            <p>
              10.1 Nous ne garantissons ni ne repr&eacute;sentons:<br />
              (a) l&rsquo;exhaustivit&eacute; ou l&rsquo;exactitude des
              informations publi&eacute;es sur notre site Web;<br />
              (b) que le mat&eacute;riel sur le site Web est &agrave; jour;
              ou<br />
              (c) que le site Web ou tout service du site Web restera
              disponible.
            </p>

            <p>
              10.2 Nous nous r&eacute;servons le droit d&rsquo;interrompre ou de
              modifier tout ou partie de nos services de site Web, et
              d&rsquo;arr&ecirc;ter de publier notre site Web, &agrave; tout
              moment, &agrave; notre seule discr&eacute;tion, sans
              pr&eacute;avis ni explication; et sauf dans la mesure
              express&eacute;ment pr&eacute;vue autrement dans les
              pr&eacute;sentes conditions g&eacute;n&eacute;rales, vous
              n&rsquo;aurez droit &agrave; aucune compensation ou autre paiement
              en cas d&rsquo;interruption ou de modification de tout service du
              site Web, ou si nous cessons de publier le site Web.
            </p>

            <p>
              10.3 Dans la mesure maximale permise par la loi applicable et sous
              r&eacute;serve de la section 11.1, nous excluons toutes les
              repr&eacute;sentations et garanties relatives &agrave;
              l&rsquo;objet de ces termes et conditions, notre site Web et
              l&rsquo;utilisation de notre site Web.
            </p>

            <p></p>

            <p>11. Limitations et exclusions de responsabilit&eacute;</p>

            <p>
              11.1 Rien dans ces termes et conditions:<br />
              (a) limiter ou exclure toute responsabilit&eacute; en cas de
              d&eacute;c&egrave;s ou de blessure r&eacute;sultant d&rsquo;une
              n&eacute;gligence;<br />
              (b) limiter ou exclure toute responsabilit&eacute; en cas de
              fraude ou de fausse d&eacute;claration frauduleuse;<br />
              (c) limiter toute responsabilit&eacute; d&rsquo;une mani&egrave;re
              non autoris&eacute;e par la loi applicable; ou<br />
              (d) exclure toute responsabilit&eacute; qui ne peut &ecirc;tre
              exclue en vertu de la loi applicable.
            </p>

            <p>
              11.2 Les limitations et exclusions de responsabilit&eacute;
              &eacute;nonc&eacute;es dans la pr&eacute;sente section 11 et
              ailleurs dans les pr&eacute;sentes conditions
              g&eacute;n&eacute;rales:<br />
              (a) (a) sont soumis &agrave; l&rsquo;article 11.1; et<br />
              (b) (b) r&eacute;gir toutes les responsabilit&eacute;s
              d&eacute;coulant des pr&eacute;sentes conditions
              g&eacute;n&eacute;rales ou li&eacute;es &agrave; l&rsquo;objet de
              ces conditions g&eacute;n&eacute;rales, y compris les
              responsabilit&eacute;s contractuelles, d&eacute;lictuelles (y
              compris la n&eacute;gligence) et pour manquement &agrave; une
              obligation l&eacute;gale, sauf dans la mesure express&eacute;ment
              pr&eacute;vu autrement dans ces termes et conditions.
            </p>

            <p>
              11.3 Dans la mesure o&ugrave; notre site Web et les informations
              et services sur notre site Web sont fournis gratuitement, nous ne
              serons pas responsables de toute perte ou dommage de quelque
              nature que ce soit.
            </p>

            <p>
              11.4 Nous ne serons pas responsables envers vous des pertes
              d&eacute;coulant de tout &eacute;v&eacute;nement ou
              &eacute;v&eacute;nement ind&eacute;pendant de notre
              volont&eacute;.
            </p>

            <p>
              11.5 Nous ne serons pas responsables envers vous des pertes
              commerciales, y compris (sans limitation) les pertes ou dommages
              aux b&eacute;n&eacute;fices, revenus, revenus, utilisation,
              production, &eacute;conomies anticip&eacute;es, affaires,
              contrats, opportunit&eacute;s commerciales ou goodwill.
            </p>

            <p>
              11.6 Nous ne serons pas responsables envers vous en cas de perte
              ou de corruption de donn&eacute;es, bases de donn&eacute;es ou
              logiciels.
            </p>

            <p>
              11.7 Nous ne serons pas responsables envers vous en cas de perte
              ou dommage sp&eacute;cial, indirect ou cons&eacute;cutif.
            </p>

            <p>
              11.8 Vous acceptez que nous ayons un int&eacute;r&ecirc;t &agrave;
              limiter la responsabilit&eacute; personnelle de nos dirigeants et
              employ&eacute;s et, eu &eacute;gard &agrave; cet
              int&eacute;r&ecirc;t, vous reconnaissez que nous sommes une
              entit&eacute; &agrave; responsabilit&eacute; limit&eacute;e; vous
              acceptez de ne pas intenter de r&eacute;clamation personnellement
              contre nos dirigeants ou employ&eacute;s en ce qui concerne les
              pertes que vous subissez en relation avec le site Web ou ces
              termes et conditions (cela ne limitera ni n&rsquo;exclura, bien
              entendu, la responsabilit&eacute; de l&rsquo;entit&eacute;
              &agrave; responsabilit&eacute; limit&eacute;e pour les actes et
              omissions de nos dirigeants et employ&eacute;s).
            </p>

            <p></p>

            <p>12. Non-respect de ces termes et conditions</p>

            <p>
              12.1 Sans pr&eacute;judice de nos autres droits en vertu des
              pr&eacute;sentes conditions g&eacute;n&eacute;rales, si vous
              enfreignez ces conditions g&eacute;n&eacute;rales de quelque
              mani&egrave;re que ce soit, ou si nous soup&ccedil;onnons
              raisonnablement que vous avez viol&eacute; ces conditions
              g&eacute;n&eacute;rales de quelque mani&egrave;re que ce soit,
              nous pouvons:<br />
              (a) (a) vous envoyer un ou plusieurs avertissements formels;<br />
              (b) (b) suspendre temporairement votre acc&egrave;s &agrave; notre
              site Web;<br />
              (c) (c) vous interdire en permanence d&rsquo;acc&eacute;der
              &agrave; notre site Web;<br />
              (d) (d) emp&ecirc;cher les ordinateurs utilisant votre adresse IP
              d&rsquo;acc&eacute;der &agrave; notre site Web;<br />
              (e) (e) contacter tout ou partie de vos fournisseurs de services
              Internet et leur demander de bloquer votre acc&egrave;s &agrave;
              notre site Web;<br />
              (f) (f) intenter une action en justice contre vous, que ce soit
              pour rupture de contrat ou autrement; et / ou<br />
              (g) suspendre ou supprimer votre compte sur notre site Web.
            </p>

            <p>
              12.2 Lorsque nous suspendons, interdisons ou bloquons votre
              acc&egrave;s &agrave; notre site Web ou &agrave; une partie de
              notre site Web, vous ne devez prendre aucune mesure pour
              contourner une telle suspension ou interdiction ou blocage (y
              compris, sans s&rsquo;y limiter, la cr&eacute;ation et / ou
              l&rsquo;utilisation d&rsquo;un compte diff&eacute;rent).
            </p>

            <p></p>

            <p>13. Variation</p>

            <p>
              13.1 Nous pouvons r&eacute;viser ces termes et conditions de temps
              &agrave; autre.
            </p>

            <p>
              13.2 OU Les termes et conditions r&eacute;vis&eacute;s
              s&rsquo;appliqueront &agrave; l&rsquo;utilisation de notre site
              Web &agrave; partir de la date de publication des termes et
              conditions r&eacute;vis&eacute;s sur le site Web, et vous renoncez
              par la pr&eacute;sente &agrave; tout droit dont vous pourriez
              avoir besoin d&rsquo;&ecirc;tre notifi&eacute; ou de consentir
              &agrave;, r&eacute;visions de ces termes et conditions.
            </p>

            <p>
              13.3 Si vous avez donn&eacute; votre accord expr&egrave;s &agrave;
              ces termes et conditions, nous vous demanderons votre accord
              expr&egrave;s &agrave; toute r&eacute;vision de ces termes et
              conditions; et si vous ne donnez pas votre accord expr&egrave;s
              aux termes et conditions r&eacute;vis&eacute;s dans le
              d&eacute;lai que nous pouvons sp&eacute;cifier, nous
              d&eacute;sactiverons ou supprimerons votre compte sur le site Web,
              et vous devrez cesser d&rsquo;utiliser le site Web.
            </p>

            <p></p>

            <p>14. Cession</p>

            <p>
              14.1 Vous acceptez par la pr&eacute;sente que nous puissions
              c&eacute;der, transf&eacute;rer, sous-traiter ou autrement traiter
              nos droits et / ou obligations en vertu de ces termes et
              conditions.
            </p>

            <p>
              14.2 Vous ne pouvez pas, sans notre consentement &eacute;crit
              pr&eacute;alable, c&eacute;der, transf&eacute;rer, sous-traiter ou
              autrement traiter l&rsquo;un de vos droits et / ou obligations en
              vertu des pr&eacute;sentes conditions g&eacute;n&eacute;rales.
            </p>

            <p></p>

            <p>15. Divisibilit&eacute;</p>

            <p>
              15.1 Si une disposition des pr&eacute;sentes conditions
              g&eacute;n&eacute;rales est jug&eacute;e ill&eacute;gale et / ou
              inapplicable par un tribunal ou une autre autorit&eacute;
              comp&eacute;tente, les autres dispositions resteront en vigueur.
            </p>

            <p>
              15.2 Si une disposition ill&eacute;gale et / ou inapplicable de
              ces conditions g&eacute;n&eacute;rales &eacute;tait l&eacute;gale
              ou ex&eacute;cutoire si une partie de celle-ci &eacute;tait
              supprim&eacute;e, cette partie sera r&eacute;put&eacute;e
              supprim&eacute;e et le reste de la disposition restera en vigueur.
            </p>

            <p></p>

            <p>16. Droits des tiers</p>

            <p>
              16.1 Un contrat en vertu de ces termes et conditions est &agrave;
              notre avantage et &agrave; votre avantage, et n&rsquo;est pas
              destin&eacute; &agrave; b&eacute;n&eacute;ficier ou &ecirc;tre
              ex&eacute;cutoire par un tiers.
            </p>

            <p>
              16.2 L&rsquo;exercice des droits des parties en vertu d&rsquo;un
              contrat en vertu des pr&eacute;sentes conditions
              g&eacute;n&eacute;rales n&rsquo;est soumis au consentement
              d&rsquo;aucun tiers.
            </p>

            <p></p>

            <p>17. Int&eacute;gralit&eacute; de l&rsquo;accord</p>

            <p>
              17.1 Sous r&eacute;serve de l&rsquo;article 11.1, ces termes et
              conditions, ainsi que notre politique de confidentialit&eacute; et
              de cookies, constitueront l&rsquo;int&eacute;gralit&eacute; de
              l&rsquo;accord entre vous et nous en ce qui concerne votre
              utilisation de notre site Web et remplaceront tous les accords
              pr&eacute;c&eacute;dents entre vous et nous en ce qui concerne
              votre utilisation de notre site Web.
            </p>

            <p></p>

            <p>18. Loi et juridiction</p>

            <p>
              18.1 Les pr&eacute;sentes conditions g&eacute;n&eacute;rales sont
              r&eacute;gies et interpr&eacute;t&eacute;es conform&eacute;ment
              &agrave; la l&eacute;gislation anglaise, espagnole,
              fran&ccedil;aise, tunisienne, alg&eacute;rienne, portugaise et
              marocaine.
            </p>

            <p>
              18.2 Tout litige relatif aux pr&eacute;sentes conditions
              g&eacute;n&eacute;rales sera soumis &agrave; la comp&eacute;tence
              exclusive OU non exclusive des tribunaux d&rsquo;Angleterre,
              d&rsquo;Espagne, de France, de Tunisie, d&rsquo;Alg&eacute;rie, du
              Portugal et du Maroc.
            </p>

            <p>19. Informations l&eacute;gales et r&eacute;glementaires</p>

            <p>
              19.1 Nous sommes inscrits au registre du commerce; ; vous pouvez
              trouver la version en ligne du registre sur URLURL, et notre
              num&eacute;ro d&rsquo;enregistrement est.
            </p>

            <p>
              19.2 Nous sommes soumis &agrave; un r&eacute;gime
              d&rsquo;autorisation, qui est supervis&eacute; par
              l&rsquo;autorit&eacute; de contr&ocirc;le.
            </p>

            <p>
              19.3 Nous sommes enregistr&eacute;s comme titre aupr&egrave;s
              d&rsquo;un organisme professionnel au Royaume-Uni et sommes soumis
              &agrave; des r&egrave;gles, qui peuvent &ecirc;tre trouv&eacute;es
              sur URL.
            </p>

            <p>
              19.4 Nous souscrivons &agrave;, qui peut &ecirc;tre
              consult&eacute; &eacute;lectroniquement au (x) code (s) de
              conduite URL (s).
            </p>

            <p>statique.L19-5-1 statique.L19-5-2.</p>

            <p></p>

            <p>20. Nos coordonn&eacute;es</p>

            <p>
              20.1 Ce site Web appartient et est exploit&eacute; par Liberrex
              LTD.
            </p>

            <p>
              20.2 Nous sommes enregistr&eacute;s en Angleterre et au Pays de
              Galles sous le num&eacute;ro d&rsquo;enregistrement 11797740, et
              notre si&egrave;ge social est situ&eacute; &agrave; Unit 6 Queens
              Yard, White Post Lane, Londres, Royaume-Uni, E9 5EN.
            </p>

            <p>
              20.3 Notre si&egrave;ge social principal est &agrave; Google
              Campus, Bonhill Street, Londres, Royaume-Uni.
            </p>

            <p>
              20.4 Vous pouvez nous contacter:<br />
              a) par courrier, en utilisant l&rsquo;adresse postale
              indiqu&eacute;e ci-dessus;<br />
              (b) en utilisant le formulaire de contact de notre site Web;<br />
              c) par t&eacute;l&eacute;phone, par t&eacute;l&eacute;phone, au
              0044 7802 40 5359; OU<br />
              (d) par e-mail, en utilisant l&rsquo;adresse e-mail publi&eacute;e
              sur notre site Internet de temps &agrave; autre.
            </p>
          </div>
        </div>

        <button class="button-terms" :style="termsType == 'Required' ? 'background-color: #72b53a;' : ''" @click="clicked()">
          {{ confirmationButton }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingPopup",
  data: function() {
    return {
      language: this.$i18n.locale,
    };
  },
  props: {
    rank: Number,
    active: Boolean,
    title: String,
    message: String,
    hint: String,
    type: String,
    confirmationButton: String,
    termsType: String
  },
  methods: {
    clicked() {
      if(this.termsType == "Required") {
        this.$emit("createCustomer");
        this.$emit("update:active", false);
      this.$emit("confirm");
      } else {
        this.$emit("update:active", false);
      this.$emit("confirm");
      }
    },
    closePopup() {
      this.$emit("update:active", false);
      this.$emit("confirm");
    }
  },
  computed: {
    isActive() {
      return this.active;
    },
  },
};
</script>

<style>
.body-devided {
  display: flex;
  margin: auto;
  width: 100%;
}

.loading-wrapper-terms {
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
}

.loading-popup-terms {
  background: #ffffff;
  width: 70vw;
  border-radius: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #264076;
}

.loader {
  width: 50px;
  height: 50px;
}

.popup-success .btn-confirm {
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 0px 0px 20px 20px;
  padding: 15px;
  width: 100%;
  border: none;
  background: #89d24c;
  color: #fff;
  font-weight: 400;
  font-size: 22px;
}

.button-terms {
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 0px 0px 20px 20px;
  padding: 15px;
  width: 100%;
  border: none;
  background: var(--secondary);
  color: #fff;
  font-weight: 400;
  font-size: 22px;
}

.popup-success .btn-confirm:not(:disabled):not(.disabled):active,
.btn-confirm:not(:disabled):not(.disabled).active,
.show > .btn-confirm.dropdown-toggle {
  color: #fff;
  background-color: #72b53a;
  border-color: #72b53a;
}

.popup-success .btn-confirm:focus,
.btn-confirm.focus {
  box-shadow: none;
}

.popup-danger .btn-confirm {
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 0px 0px 20px 20px;
  padding: 15px;
  width: 100%;
  border: none;
  background: #dc3545;
  color: #fff;
  font-weight: 400;
  font-size: 22px;
}

.popup-danger .btn-confirm:not(:disabled):not(.disabled):active,
.btn-confirm:not(:disabled):not(.disabled).active,
.show > .btn-confirm.dropdown-toggle {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}

.popup-danger .btn-confirm:focus,
.btn-confirm.focus {
  box-shadow: none;
}

.body-text {
  margin-top: 20px;
  overflow-y: scroll;
  height: 50vh;
}
@media screen and (max-width: 768px) {
  .body-text {
    margin-top: 20px;
    overflow-y: scroll;
    height: 40vh;
  }
}
</style>
